import React, { useEffect, useState } from 'react'
import WorkItems from './WorkItems'
import projectsData from '../../assets/projectsData.json'

const projectsNav = [
    { name: 'all' },
    { name: 'web' },
    { name: 'Machine Learning' },
    { name: 'others' },
]

const Works = () => {
    const [item, setItem] = useState({ name: 'all' })
    const [projects, setProjects] = useState([])
    const [active, setActive] = useState(0)

    useEffect(() => {
        if (item.name === 'all') {
            setProjects(projectsData)
        } else {
            setProjects(
                projectsData.filter(
                    (project) => project.category.toLowerCase() === item.name
                )
            )
        }
    }, [item])

    const handleClick = (e, index) => {
        setItem({ name: e.target.textContent.toLowerCase() })
        setActive(index)
    }

    return (
        <div>
            <div className="work__filters">
                {projectsNav.map((navItem, index) => (
                    <span
                        key={index}
                        onClick={(e) => handleClick(e, index)}
                        className={`${active === index ? 'active-work' : ''} work__item`}
                    >
            {navItem.name}
          </span>
                ))}
            </div>

            <div className="work__container container grid">
                {projects.map((project) => (
                    <WorkItems key={project.id} item={project} />
                ))}
            </div>
        </div>
    )
}

export default Works
